import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Download } from 'lucide-react';
import { downloadPrelimsPdf } from '../../services/api';
import './LandingPage.css';

export default function DailyMockTest() {
  const [busy, setBusy] = useState('');
  const [err, setErr] = useState('');
  const now = new Date();
  const date = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata' }).format(now);
  const label = now.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'Asia/Kolkata',
  });

  const get = async answerSheet => {
    setBusy(answerSheet ? 'a' : 'q');
    setErr('');
    try {
      await downloadPrelimsPdf({ date, answerSheet });
    } catch (e) {
      setErr(e.response?.data?.message || e.message || 'Download failed. Try again.');
    } finally {
      setBusy('');
    }
  };

  return (
    <section id="mock" className="cf-sec cream">
      <h2 className="cf-title">Daily UPSC Prelims Mock Test</h2>
      <p className="cf-sub">Practice with today's question paper, dated {label}.</p>
      <div className="cf-dl">
        <button className="rust" disabled={!!busy} onClick={() => get(false)}>
          <span className="dot"><Download size={26} /></span>
          {busy === 'q' ? 'Preparing…' : 'Question paper'}
        </button>
        <button className="teal" disabled={!!busy} onClick={() => get(true)}>
          <span className="dot"><Download size={26} /></span>
          {busy === 'a' ? 'Preparing…' : 'Answer sheet'}
        </button>
      </div>
      {err && <p className="cf-err" role="alert">{err}</p>}
      <p className="cf-feature-link"><Link to="/mock-test">Open the daily mock test page →</Link></p>
    </section>
  );
}
